import React from 'react';
import { Pressable, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { Card, Text } from '@/ui';
import { Icon } from '@/ui/icon';

interface CardSwitchProps {
  icon: React.ReactNode;
  iconText: string;
  caption: string;
  title: string;
  onPress: () => void;
  active?: boolean;
  style?: any;
}

export default function CardSwitch({
  icon,
  iconText,
  caption,
  title,
  onPress,
  active = false,
  style,
}: CardSwitchProps) {
  const { theme } = useStyles();

  return (
    <Pressable style={style} onPress={onPress} hitSlop={8}>
      <Card
        style={{
          backgroundColor: active
            ? theme.colors.cardSwitch.active.backgroundColor
            : theme.colors.cardSwitch.default.backgroundColor,
        }}
      >
        <View style={{ padding: 16, gap: 8 }}>
          <View
            style={{
              flexDirection: 'row',
              gap: 8,
              alignItems: 'center',
            }}
          >
            <Icon
              type="dressed"
              icon={icon}
              width={25}
              height={25}
              style={{
                backgroundColor: active
                  ? theme.colors.cardSwitch.active.icon.backgroundColor
                  : theme.colors.cardSwitch.default.icon.backgroundColor,
                borderColor: active
                  ? theme.colors.cardSwitch.active.icon.border
                  : theme.colors.cardSwitch.default.icon.border,
              }}
              fillColor={theme.colors.icon.color}
            />

            <Text
              type="bodyRegular"
              style={{
                flex: 1,
                color: active
                  ? theme.colors.text.inverse
                  : theme.colors.text.primary,
              }}
            >
              {iconText}
            </Text>
          </View>

          <View style={{ gap: 8 }}>
            <Text
              type="caption1"
              style={{
                color: active
                  ? theme.colors.text.inverse
                  : theme.colors.text.primary,
              }}
            >
              {caption}
            </Text>

            <Text
              type="title1"
              style={{
                color: active
                  ? theme.colors.text.inverse
                  : theme.colors.text.primary,
              }}
            >
              {title}
            </Text>
          </View>
        </View>
      </Card>
    </Pressable>
  );
}
